import script from "./CoachingReportsBox.vue?vue&type=script&setup=true&lang=js"
export * from "./CoachingReportsBox.vue?vue&type=script&setup=true&lang=js"

import "./CoachingReportsBox.vue?vue&type=style&index=0&id=8ff7280e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ff7280e"]])

export default __exports__